import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Projeto } from 'src/app/core/projeto';
import { Rotas } from 'src/app/core/rotas';
import { BaseService } from '../base/base.service';


const rootPath = 'api/projeto/';

@Injectable({
  providedIn: 'root'
})
export class ProjetoService extends BaseService<Projeto> {
  
  constructor(http: HttpClient) {
    super(http, Rotas.PROJETOS);
  }

  getAllIntituicaoLogada() {
    return this.http.get(`${Rotas.PROJETOS}instituicao/logada`);
  }

  getAllPorPrograma(idPrograma: number) {
    return this.http.get(`${Rotas.PROJETOS}programa/${idPrograma}`);
  }

  getAllProgramasIntituicaoLogadaCombo() {
    return this.http.get(`${Rotas.PROJETOS}instituicao/logada/combo`);
  }

  getAllCombo() {
    return this.http.get(`${Rotas.PROJETOS}dados/combo`);
  }

  getAllComboByContrato(idContrato: number) {
    return this.http.get(`${Rotas.PROJETOS}dados/combo/${idContrato}`);
  }
}
